import OpticksBackground from "@/components/ui/OpticksBackground/OpticksBackground";
import OpticksLink from "@/components/ui/OpticksLink/OpticksLink";
import OpticksMessage from "@/components/ui/OpticksMessage/OpticksMessage";

const Blocked = () => {
  return (
    <OpticksBackground>
      <OpticksMessage type="blocked">
        <b>
          Your account has been blocked. This may be due to an expired or
          inactive account status or a violation of our terms of use.
        </b>
        <br />
        If you believe this is a mistake, please contact our support team at{" "}
        <OpticksLink
          href="mailto:support@optickssecurity.com"
          label="support@optickssecurity.com"
        />
      </OpticksMessage>
    </OpticksBackground>
  );
};

export default Blocked;
